<app-dialog [title]="dialogTitle" (close)="close()">
    <ng-container dialogHeader>
        <panel-tools
            [showRequiredLabel]="true"
            [isPanelToolsDialog]="true"
            [showLangButton]="service.languageCount > 1"
            (setCurrentLangForm)="setCurrentLangForm($event)"
        >
        </panel-tools>
    </ng-container>
    <ng-container dialogContent>
        <div #formRef [formGroup]="form">
            <ng-container>
                <ng-container [ngSwitch]="data.type">
                    <ng-container *ngSwitchCase="'folder'" [ngTemplateOutlet]="menuFolderTemplate"></ng-container>
                    <ng-container *ngSwitchCase="'url'" [ngTemplateOutlet]="menuURLTemplate"></ng-container>
                    <ng-container *ngSwitchCase="'registry'" [ngTemplateOutlet]="menuRegistryTemplate"></ng-container>
                    <ng-container *ngSwitchCase="'controller'" [ngTemplateOutlet]="menuControlTemplate"> </ng-container>
                    <ng-container *ngSwitchCase="'page'" [ngTemplateOutlet]="menuPageTemplate"></ng-container>
                </ng-container>
            </ng-container>
        </div>
    </ng-container>
    <ng-container dialogActions>
        <fui-button
            (clickEvent)="save()"
            [icon]="'content-save'"
            [label]="service.language_dictionary.system_save"
            [height]="'mini'"
        >
        </fui-button>
        <fui-button
            (clickEvent)="close()"
            [icon]="'close'"
            [label]="service.language_dictionary.system_close"
            [color]="'light'"
            [height]="'mini'"
        >
        </fui-button>
    </ng-container>
</app-dialog>

<!--------------------------------------Шаблоны отображения формы---------------------------->
<!-- Шаблон формы URL -->
<ng-template #menuURLTemplate>
    <div fxLayout="column">
        <div fxFlex="0 0 100%" fxLayoutGap="8px">
            <ng-container [ngTemplateOutlet]="menuFieldNameTemplate"></ng-container>
        </div>
        <div fxFlex="0 0 100%" fxLayoutGap="8px">
            <ng-container [ngTemplateOutlet]="menuFieldURLTemplate"></ng-container>
        </div>
        <div class="flex flex-row gap-x-[8px]">
            <div class="basis-full w-2/3">
                <ng-container [ngTemplateOutlet]="menuFieldRoleIdTemplate"></ng-container>
            </div>
            <ng-container *ngIf="data.data.level === 0">
                <div class="basis-1/3 w-1/3">
                    <ng-container [ngTemplateOutlet]="menuFieldCssClassTemplate"></ng-container>
                </div>
            </ng-container>
        </div>
    </div>
</ng-template>
<!-- Шаблон формы Папка -->
<ng-template #menuFolderTemplate>
    <div fxLayout="column">
        <div fxFlex="0 0 100%">
            <ng-container [ngTemplateOutlet]="menuFieldNameTemplate"></ng-container>
        </div>
        <div class="flex flex-row gap-x-[8px]">
            <div class="basis-full w-2/3">
                <ng-container [ngTemplateOutlet]="menuFieldRoleIdTemplate"></ng-container>
            </div>
            <ng-container *ngIf="data.data.level === 0">
                <div class="basis-1/3 w-1/3">
                    <ng-container [ngTemplateOutlet]="menuFieldCssClassTemplate"></ng-container>
                </div>
            </ng-container>
        </div>
    </div>
</ng-template>
<!-- Шаблон формы Контроллера -->
<ng-template #menuControlTemplate>
    <div fxLayout="column">
        <div fxFlex="0 0 100%">
            <ng-container [ngTemplateOutlet]="menuFieldNameTemplate"></ng-container>
        </div>
        <div fxFlex="0 0 100%">
            <ng-container [ngTemplateOutlet]="menuFieldURLTemplate"></ng-container>
        </div>
        <div class="flex flex-row gap-x-[8px]">
            <div class="basis-full w-2/3">
                <ng-container [ngTemplateOutlet]="menuFieldActionNameTemplate"></ng-container>
            </div>
            <ng-container *ngIf="data.data.level === 0">
                <div class="basis-1/3 w-1/3">
                    <ng-container [ngTemplateOutlet]="menuFieldCssClassTemplate"></ng-container>
                </div>
            </ng-container>
        </div>
        <div class="flex flex-row gap-x-[8px]">
            <ng-container [ngTemplateOutlet]="menuFieldNewInterfaceTemplate"></ng-container>
        </div>
    </div>
</ng-template>
<!-- Шаблон формы Реестр -->
<ng-template #menuRegistryTemplate>
    <div fxLayout="column">
        <div fxFlex="0 0 100%">
            <ng-container [ngTemplateOutlet]="menuFieldNameTemplate"></ng-container>
        </div>
        <div class="flex flex-row gap-x-[8px]">
            <div class="basis-full w-2/3">
                <ng-container [ngTemplateOutlet]="menuFieldFactorTemplate"></ng-container>
            </div>
            <ng-container *ngIf="data.data.level === 0">
                <div class="basis-1/3 w-1/3">
                    <ng-container [ngTemplateOutlet]="menuFieldCssClassTemplate"></ng-container>
                </div>
            </ng-container>
        </div>
    </div>
</ng-template>
<!-- Шаблон формы Page -->
<ng-template #menuPageTemplate>
    <div fxLayout="column">
        <div fxFlex="0 0 100%" fxLayoutGap="8px">
            <ng-container [ngTemplateOutlet]="menuFieldNameTemplate"></ng-container>
        </div>
        <div class="flex flex-row gap-x-[8px]">
            <div class="basis-full w-2/3">
                <ng-container [ngTemplateOutlet]="menuFieldRoleIdTemplate"></ng-container>
            </div>
            <ng-container *ngIf="data.data.level === 0">
                <div class="basis-1/3 w-1/3">
                    <ng-container [ngTemplateOutlet]="menuFieldCssClassTemplate"></ng-container>
                </div>
            </ng-container>
        </div>
    </div>
</ng-template>
<!--------------------------------------[END] Шаблоны отображения формы---------------------------->
<!--------------------------------------Шаблоны отображения полей формы---------------------------->
<!-- Шаблон поля названия элемента -->
<ng-template #menuFieldNameTemplate>
    <div *ngFor="let lang of service?.languages | keyvalue" [class.!hidden]="lang?.value !== currentLangForm">
        <ng-container
            dynamic-field
            [field]="{
                type: 'input',
                label:
                    service.language_dictionary.system_name +
                    (service.languageCount > 1 ? ' (' + lang?.value?.lang + ')' : ''),
                inputType: 'name',
                name: lang?.value?.lang,
                required: lang?.value?.lang === appService.defaultLanguage,
                validations: [
                    {
                        name: 'required',
                        message: service.language_dictionary.system_field_required,
                    },
                    {
                        name: 'serverError',
                    },
                ],
            }"
            [group]="form?.get('name')"
        >
        </ng-container>
    </div>
</ng-template>
<!-- Шаблон поля класс иконки элемента -->
<ng-template #menuFieldCssClassTemplate>
    <ng-container
        dynamic-field
        [field]="{
            type: 'input',
            label: service.language_dictionary.menu_icon_class,
            inputType: 'text',
            name: 'css_class',
            validations: [
                {
                    name: 'required',
                    message: service.language_dictionary.system_field_required,
                },
                {
                    name: 'serverError',
                },
            ],
        }"
        [group]="form"
    >
    </ng-container>
</ng-template>
<!-- Шаблон поля урл -->
<ng-template #menuFieldURLTemplate>
    <ng-container
        dynamic-field
        [field]="{
            type: 'input',
            label: service.language_dictionary.menu_page_address,
            inputType: 'text',
            name: 'url',
            required: true,
            validations: [
                {
                    name: 'required',
                    message: service.language_dictionary.system_field_required,
                },
                {
                    name: 'serverError',
                },
            ],
        }"
        [group]="form"
    >
    </ng-container>
</ng-template>
<!-- Шаблон поля имя контроллера -->
<ng-template #menuFieldActionNameTemplate>
    <ng-container
        dynamic-field
        [field]="{
            type: 'select-search',
            label: service.language_dictionary.menu_controller_name,
            inputType: 'text',
            name: 'action_name',
            required: true,
            options: service.guides.system_sections,
            multiple: false,
            validations: [
                {
                    name: 'required',
                    message: appService.language_dictionary.system_field_required,
                },
                {
                    name: 'serverError',
                },
            ],
        }"
        [group]="form"
    >
    </ng-container>
</ng-template>
<!-- Шаблон поля стартовая страница -->
<ng-template #menuFieldStartPageTemplate>
    <div class="form-field-margin-bottom">
        <ng-container
            dynamic-field
            [field]="{
                type: 'checkbox',
                label: service.language_dictionary.menu_start_page,
                name: 'is_start_page',
            }"
            [group]="form"
        >
        </ng-container>
    </div>
</ng-template>
<!-- Шаблон поля ссылка нового интерфейса страница -->
<ng-template #menuFieldNewInterfaceTemplate>
    <div class="form-field-margin-bottom">
        <ng-container
            dynamic-field
            [field]="{
                type: 'checkbox',
                label: service.language_dictionary.menu_is_new_link,
                name: 'is_new_link',
            }"
            [group]="form"
        >
        </ng-container>
    </div>
</ng-template>
<!-- Шаблон поля реестр -->
<ng-template #menuFieldFactorTemplate>
    <ng-container
        dynamic-field
        [field]="{
            type: 'select-search',
            label: appService.language_dictionary.system_registry,
            inputType: 'text',
            name: 'factor_id',
            required: true,
            options: service.guides.all_registry,
            multiple: false,
            validations: [
                {
                    name: 'required',
                    message: appService.language_dictionary.system_field_required,
                },
                {
                    name: 'serverError',
                },
            ],
        }"
        [group]="form"
    >
    </ng-container>
</ng-template>
<!-- Шаблон поля Роли -->
<ng-template #menuFieldRoleIdTemplate>
    <ng-container
        dynamic-field
        [field]="{
            type: 'select-search',
            label: appService.language_dictionary.menu_role_id,
            inputType: 'text',
            name: 'role_id',
            required: true,
            options: service.guides.roles,
            multiple: true,
            validations: [
                {
                    name: 'required',
                    message: appService.language_dictionary.system_field_required,
                },
                {
                    name: 'serverError',
                },
            ],
        }"
        [group]="form"
    >
    </ng-container>
</ng-template>
<!--------------------------------------[END]Шаблоны отображения полей формы---------------------------->
